export const GET_ROLES_BEGIN   = 'GET_ROLES_BEGIN';
export const GET_ROLES_SUCCES   = 'GET_ROLES_SUCCES';
export const GET_ROLES_FAILURE   = 'GET_ROLES_FAILURE';

export const GET_ACCOUNTS_BEGIN   = 'GET_ACCOUNTS_BEGIN';
export const GET_ACCOUNTS_SUCCES   = 'GET_ACCOUNTS_SUCCES';
export const GET_ACCOUNTS_FAILURE   = 'GET_ACCOUNTS_FAILURE';

export const ROLE_LOGOUT   = 'ROLE_LOGOUT';


export function getrolesaction(token,params) {
  let apiurl = window.apiurl
    return dispatch => {
      
        dispatch(getRolesBegin());
        return fetch("https://"+apiurl+"/api/AccessRole", {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          },
          body: JSON.stringify(params) 
        })
          .then(handleErrors)
          .then(res => res.json())
          .then(json => {
            dispatch(getRolesSuccess(json));
            return json;
          })
          .catch(error => dispatch(getRolesFailure(error)));
      }
  }



  export function getaccountsaction(token,params) {
    let apiurl = window.apiurl
      return dispatch => {
        
          dispatch(getAccountsBegin());
          return fetch("https://"+apiurl+"/api/Account", {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify(params) 
          })
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
              dispatch(getAccountsSuccess(json));
              return json;
            })
            .catch(error => dispatch(getAccountsFailure(error)));
        }
    }


    
    
  
    function handleErrors(response) {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    }


    export const getRolesBegin = () => ({
        type: GET_ROLES_BEGIN
      });


    export const getRolesSuccess = roledata => ({
        type: GET_ROLES_SUCCES,
        payload: { roledata }
      });
      
    export const getRolesFailure = error => ({
        type: GET_ROLES_FAILURE,
        payload: { error }
      });

      export const getAccountsBegin = () => ({
        type: GET_ACCOUNTS_BEGIN
      });


    export const getAccountsSuccess = accountsdata => ({
        type: GET_ACCOUNTS_SUCCES,
        payload: { accountsdata }
      });
      
    export const getAccountsFailure = error => ({
        type: GET_ACCOUNTS_FAILURE,
        payload: { error }
      });

    export const roleLogout = () => ({
        type: ROLE_LOGOUT,
      });

    